import React from 'react';
import {
  Box, Button,
  CardHeader, Divider,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  TextField
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import EditIcon from '@material-ui/icons/Edit';
import { Formik } from 'formik';
import MaterialTable from 'material-table';
import { forwardRef, useEffect, useState } from 'react';
import * as Yup from "yup";

export default function Fiering({
  handleNext,
  handleBack,
  isUpdate,
  firingDetails,
  setFiringDetails,
  StatusID,
  witheringDetails,
  manufacturingDetail,
  selectedDhools,
  gradeDetails,
  rollingDetails
}) {
  const [dhholds, setDhholds] = useState([]);

  useEffect(() => {
    const initialDhools = (firingDetails.selectedDhools?.length > 0
      ? firingDetails.selectedDhools
      : selectedDhools || []
    ).map(dhool => ({
      ...dhool,
      dhoolQuantity: dhool.dhoolQuantity || 0
    }));
    setDhholds(initialDhools);
  }, [firingDetails.selectedDhools, selectedDhools]);

  useEffect(() => {
    if (dhholds.length === 0) return;

    const totalQuantity = dhholds.reduce((sum, dhool) => sum + (parseFloat(dhool.dhoolQuantity) || 0), 0);
    const grossOutTurn = parseFloat((totalQuantity / manufacturingDetail.greenLeafAmount) * 100).toFixed(1);
    const moistureGain = parseFloat(Math.max(0, gradeDetails.refuseAmount - gradeDetails.remainingAmount)).toFixed(2);
    const totalFiredLeaf = parseFloat(parseFloat(totalQuantity) + parseFloat(moistureGain)).toFixed(2);
    //const grandGrossOutTurn = parseFloat((totalFiredLeaf / manufacturingDetail.greenLeafAmount) * 100).toFixed(1);

    if (
      firingDetails.fireWeight !== totalQuantity.toFixed(2) ||
      firingDetails.grossOutTurn !== grossOutTurn ||
      firingDetails.moistureGain !== moistureGain ||
      firingDetails.totalFireWeight !== totalFiredLeaf 
      //firingDetails.grandGrossOutTurn !== grandGrossOutTurn
    ) {
      setFiringDetails(prevState => ({
        ...prevState,
        fireWeight: totalQuantity.toFixed(2),
        grossOutTurn: grossOutTurn,
        selectedDhools: dhholds,
        moistureGain: moistureGain,
        totalFireWeight: totalFiredLeaf,
        //grandGrossOutTurn: grandGrossOutTurn
      }));
    }
  }, [dhholds, manufacturingDetail.greenLeafAmount, gradeDetails, firingDetails]);

  useEffect(() => {
    if (isUpdate && parseInt(firingDetails.fireWeight) == 0) {
      setFiringDetails(prevDetails => ({
        ...prevDetails,
        startDateTime: rollingDetails.rollingEndDate,
        endDateTime: rollingDetails.rollingEndDate
      }));
    }
  }, [rollingDetails.rollingEndDate]);

  useEffect(() => {
    if (rollingDetails.rollingEndDate && !firingDetails.startDateTime) {
      const startDate = new Date(rollingDetails.rollingEndDate);
      const formattedStart = formatDateTime(startDate);

      const endDate = new Date(startDate);
      const formattedEnd = formatDateTime(endDate);

      setFiringDetails(prev => ({
        ...prev,
        startDateTime: formattedStart,
        endDateTime: formattedEnd
      }));
    }
  }, [rollingDetails.rollingEndDate]);

  function handleChange(e) {
    const target = e.target;
    const value = target.value

    if (e.target.name != "fireWeight" && e.target.name != "temperature") {
      setFiringDetails({
        ...firingDetails,
        [e.target.name]: value
      });
    }
    else {
      const finalValue = value == "" ? parseFloat(0) : value
      var reg = new RegExp('^[0-9]{0,9}([.]?[0-9]{0,2})?$');
      if (reg.test(finalValue) == false) {
        return;
      }
      setFiringDetails({
        ...firingDetails,
        [e.target.name]: finalValue == "" ? parseFloat(0) : parseFloat(finalValue)
      });
    }
  }

  const formatDateTime = (date) => {
    if (!date) return "";
    const d = new Date(date);

    const pad = n => n.toString().padStart(2, '0');
    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <Formik
        initialValues={{
          startDateTime: firingDetails.startDateTime,
          endDateTime: firingDetails.endDateTime,
          fireWeight: firingDetails.fireWeight,
          temperature: firingDetails.temperature,
          temperatureUnitID: firingDetails.temperatureUnitID
        }}
        validationSchema={
          Yup.object().shape({
            startDateTime: Yup.string().required('Start Date is required').typeError('Invalid date'),
            endDateTime: Yup.string().required('End Date is required').typeError('Invalid date'),
            fireWeight: Yup.number().required('Total Fire Weight is required').min(0.1, 'Total Fire Weight should be grater than 0')
              .max(manufacturingDetail.greenLeafAmount, "Total Fire Weight should be less than Green Leaf Quantity"),
            fireWeight: Yup.number()
              .required('Total Fire Weight is required')
              .min(0.1, 'Total Fire Weight should be greater than 0')
              .max(witheringDetails.witheredLeafAmount, "Total Fire Weight should not exceed withered leaf"),
            temperature: Yup.number().required('Temperature is required').min(0.1, 'Temperature should be grater than 0'),
            temperatureUnitID: Yup.number().required('Temperature Unit is required').min("1", 'Temperature Unit is required')
          })
        }
        enableReinitialize
      >
        {({
          errors,
          handleBlur,
          handleSubmit,
          touched,
          setTouched,
          validateForm,
          setFieldValue,
          isValid,
        }) => (
          <form onSubmit={handleSubmit}>
            <>
              <CardHeader title={"Firing"} />
              <Divider />
              &nbsp;
              <Grid container spacing={3}>
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="startDateTime">
                    Start Date & Time *
                  </InputLabel>
                  <TextField
                    fullWidth
                    error={Boolean(touched.startDateTime && errors.startDateTime)}
                    helperText={touched.startDateTime && errors.startDateTime}
                    name="startDateTime"
                    type="datetime-local"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    value={firingDetails.startDateTime}
                    variant="outlined"
                    id="startDateTime"
                    size='small'
                    onKeyDown={onKeyDown}
                    inputProps={{
                      min: rollingDetails.rollingEndDate,
                      max: formatDateTime(manufacturingDetail.toDateOfManufacture)
                    }}
                    InputProps={{
                      readOnly: StatusID == 2 || StatusID == 3
                    }}
                  >
                  </TextField>
                </Grid>
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="endDateTime">
                    End Date & Time *
                  </InputLabel>
                  <TextField
                    fullWidth
                    error={Boolean(touched.endDateTime && errors.endDateTime)}
                    helperText={touched.endDateTime && errors.endDateTime}
                    type="datetime-local"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="endDateTime"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e)
                    }}
                    value={firingDetails.endDateTime}
                    variant="outlined"
                    id="endDateTime"
                    size='small'
                    inputProps={{
                      min: rollingDetails.rollingEndDate,
                      max: formatDateTime(manufacturingDetail.toDateOfManufacture)
                    }}
                    onKeyDown={onKeyDown}
                    InputProps={{
                      readOnly: StatusID == 2 || StatusID == 3
                    }}
                  >
                  </TextField>
                </Grid>
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="fireWeight">
                    Fire Weight
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.fireWeight && errors.fireWeight)}
                    fullWidth
                    helperText={touched.fireWeight && errors.fireWeight}
                    name="fireWeight"
                    onBlur={() => {
                      setTouched({ ...touched, fireWeight: true });
                    }}
                    value={firingDetails.fireWeight}
                    variant="outlined"
                    id="fireWeight"
                    size='small'
                    InputProps={{
                      readOnly: true,
                      inputProps: {
                        step: 0.01,
                        type: 'number',
                        style: {
                          textAlign: 'right',
                        },
                      },
                    }}
                    onKeyDown={(evt) =>
                      (evt.key === "-") && evt.preventDefault()
                    }
                    onWheel={event => event.target.blur()}
                  >
                  </TextField>
                </Grid>
                {/* <Grid item md={3} xs={8}>
                  <InputLabel shrink id="totalFireWeight">
                    Total Fire Weight
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.totalFireWeight && errors.totalFireWeight)}
                    fullWidth
                    helperText={touched.totalFireWeight && errors.totalFireWeight}
                    name="totalFireWeight"
                    onBlur={handleBlur}
                    value={firingDetails.totalFireWeight}
                    variant="outlined"
                    id="totalFireWeight"
                    size='small'
                    InputProps={{
                      readOnly: true,
                      inputProps: {
                        step: 0.01,
                        type: 'number',
                        style: {
                          textAlign: 'right',
                        },
                      },
                    }}
                    onKeyDown={(evt) =>
                      (evt.key === "-") && evt.preventDefault()
                    }
                    onWheel={event => event.target.blur()}
                  >
                  </TextField>
                </Grid> */}
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="grossOutTurn">
                    Gross Outturn (%)
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.grossOutTurn && errors.grossOutTurn)}
                    fullWidth
                    helperText={touched.grossOutTurn && errors.grossOutTurn}
                    name="grossOutTurn"
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    value={firingDetails.grossOutTurn}
                    variant="outlined"
                    id="grossOutTurn"
                    size='small'
                    InputProps={{
                      readOnly: true,
                      inputProps: {
                        step: 0.01,
                        type: 'number',
                        style: {
                          textAlign: 'right',
                        },
                      },
                    }}
                    onKeyDown={(evt) =>
                      (evt.key === "-") && evt.preventDefault()
                    }
                    onWheel={event => event.target.blur()}
                  >
                  </TextField>
                </Grid>
                {/* <Grid item md={3} xs={8}>
                  <InputLabel shrink id="grandGrossOutTurn">
                    Grand Gross Outturn (%)
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.grandGrossOutTurn && errors.grandGrossOutTurn)}
                    fullWidth
                    helperText={touched.grandGrossOutTurn && errors.grandGrossOutTurn}
                    name="grandGrossOutTurn"
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    value={firingDetails.grandGrossOutTurn}
                    variant="outlined"
                    id="grandGrossOutTurn"
                    size='small'
                    InputProps={{
                      readOnly: true,
                      inputProps: {
                        step: 0.01,
                        type: 'number',
                        style: {
                          textAlign: 'right',
                        },
                      },
                    }}
                    onKeyDown={(evt) =>
                      (evt.key === "-") && evt.preventDefault()
                    }
                    onWheel={event => event.target.blur()}
                  >
                  </TextField>
                </Grid> */}
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="temperature">
                    Temperature *
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.temperature && errors.temperature)}
                    fullWidth
                    helperText={touched.fireWeight && errors.temperature}
                    name="temperature"
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    value={firingDetails.temperature}
                    variant="outlined"
                    id="temperature"
                    size='small'
                    InputProps={{
                      readOnly: StatusID == 2 || StatusID == 3,
                      inputProps: {
                        step: 0.01,
                        type: 'number',
                        style: {
                          textAlign: 'right',
                        },
                      },
                    }}
                    onKeyDown={(evt) =>
                      (evt.key === "-") && evt.preventDefault()
                    }
                    onWheel={event => event.target.blur()}
                  >
                  </TextField>
                </Grid>
                <Grid item md={3} xs={8}>
                  <InputLabel shrink id="temperatureUnitID">
                    Temperature Unit *
                  </InputLabel>
                  <TextField
                    select
                    error={Boolean(touched.temperatureUnitID && errors.temperatureUnitID)}
                    fullWidth
                    helperText={touched.temperatureUnitID && errors.temperatureUnitID}
                    name="temperatureUnitID"
                    onBlur={handleBlur}
                    onChange={(e) => handleChange(e)}
                    value={firingDetails.temperatureUnitID}
                    variant="outlined"
                    id="temperatureUnitID"
                    size='small'
                    InputProps={{
                      readOnly: StatusID == 2 || StatusID == 3
                    }}
                  >
                    <MenuItem value="0">--Select Temperature Unit--</MenuItem>
                    <MenuItem value="1">C</MenuItem>
                    <MenuItem value="2">K</MenuItem>
                    <MenuItem value="3">F</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
              &nbsp;
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Box mt={2}>
                    <MaterialTable
                      title={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ fontSize: '1.0rem', fontWeight: 600, color: '#3f51b5' }}>
                            Dhool Quantities
                          </span>
                        </div>
                      }
                      columns={[
                        {
                          title: 'Dhool',
                          field: 'dhoolName',
                          editable: 'never',
                          headerStyle: {
                            backgroundColor: '#f5f5f5',
                            fontWeight: 'bold',
                            fontSize: '0.95rem'
                          },
                          cellStyle: {
                            fontWeight: 500
                          }
                        },
                        {
                          title: 'Quantity',
                          field: 'dhoolQuantity',
                          type: 'numeric',
                          validate: rowData => rowData.dhoolQuantity > 0 ? true : 'Quantity must be greater than 0',
                          headerStyle: {
                            backgroundColor: '#f5f5f5',
                            fontWeight: 'bold',
                            fontSize: '0.95rem'
                          },
                          cellStyle: {
                            textAlign: 'right',
                            paddingRight: '30px'
                          },
                          editComponent: props => (
                            <TextField
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={props.value || ''}
                              onChange={e => props.onChange(e.target.value)}
                              inputProps={{
                                min: 0,
                                step: 0.01,
                                style: {
                                  textAlign: 'right',
                                  padding: '8px 12px'
                                }
                              }}
                              onKeyDown={(evt) => (evt.key === "-" || evt.key === "e") && evt.preventDefault()}
                              onWheel={event => event.target.blur()}
                              InputProps={{
                                endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                              }}
                              error={props.value <= 0}
                              helperText={props.value <= 0 ? 'Value must be greater than zero.' : ''}
                            />
                          )
                        }
                      ]}
                      data={dhholds}
                      editable={{
                        onRowUpdate: (newData, oldData) =>
                          new Promise((resolve) => {
                            const updatedDhholds = dhholds.map(dhool =>
                              dhool.dhoolID === oldData.dhoolID ? {
                                ...newData,
                                dhoolQuantity: parseFloat(newData.dhoolQuantity) || 0
                              } : dhool
                            );
                            setDhholds(updatedDhholds);
                            setFiringDetails(prevState => ({
                              ...prevState,
                              selectedDhools: updatedDhholds
                            }));
                            resolve();
                          }),
                      }}
                      options={{
                        search: false,
                        paging: false,
                        actionsColumnIndex: -1,
                        maxBodyHeight: '300px',
                        headerStyle: {
                          backgroundColor: '#f5f5f5',
                          fontWeight: 'bold'
                        },
                        rowStyle: {
                          height: '20px'
                        },
                        actionsCellStyle: {
                          paddingRight: '20px'
                        },
                        editCellStyle: {
                          padding: '8px'
                        }
                      }}
                      actions={[]}
                      localization={{
                        body: {
                          editRow: {
                            deleteText: 'Are you sure you want to update this quantity?',
                            saveTooltip: 'Confirm',
                            cancelTooltip: 'Cancel'
                          }
                        }
                      }}
                      components={{
                        EditField: props => (
                          <TextField
                            {...props}
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                        )
                      }}
                      icons={{
                        Edit: forwardRef((props, ref) => (
                          <EditIcon {...props} ref={ref} style={{ color: '#2690f3' }} />
                        )),
                        Check: forwardRef((props, ref) => (
                          <CheckIcon {...props} ref={ref} style={{ color: '#4caf50' }} />
                        )),
                        Clear: forwardRef((props, ref) => (
                          <ClearIcon {...props} ref={ref} style={{ color: '#f44336' }} />
                        ))
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
              &nbsp;
              <Box display="flex" justifyContent="flex-end">
                <Button
                  color="primary"
                  variant="contained"
                  type='button'
                  size='small'
                  onClick={handleBack}
                >
                  Back
                </Button>
                &nbsp;
                <Button
                  color="primary"
                  variant="contained"
                  type='button'
                  size='small'
                  onClick={async () => {
                    await setTouched({
                      startDateTime: true,
                      endDateTime: true,
                      fireWeight: true,
                      temperature: true,
                      temperatureUnitID: true
                    });
                    const formErrors = await validateForm();
                    if (Object.keys(formErrors).length === 0) {
                      handleNext();
                    }
                  }}
                  disabled={
                    dhholds.some((dhool) => !dhool.dhoolQuantity || isNaN(dhool.dhoolQuantity) || dhool.dhoolQuantity <= 0)
                  }
                >
                  Next
                </Button>
              </Box>
            </>
          </form>
        )}
      </Formik >
    </>
  )
}
